import { useTranslation } from 'react-i18next';
import { Icon } from '../shared/components/Icon';
import { PoweredBy } from '../shared/components/ui';
import { useWorkspace, useWorkspaceActions } from './WorkspaceProvider';

/**
 * The line that closes the workspace: what is open, the two commands that act on the
 * whole arrangement, and the vendor credit that closes every Varza shell.
 */
export function WorkspaceStatusBar() {
  const { t } = useTranslation();
  const state = useWorkspace();
  const { dispatch } = useWorkspaceActions();
  const open = Object.keys(state.panels).length;
  const floating = state.windows.length;

  return (
    <div className="workspace-status">
      <span className="workspace-status__count">
        <Icon name="layout" className="icon icon--small" />
        {t('workspace.openCount', { count: open })}
        {floating === 0 ? null : <em>{t('workspace.floatingCount', { count: floating })}</em>}
      </span>

      <span className="workspace-status__actions">
        <button
          type="button"
          className="workspace-status__action"
          disabled={open === 0}
          onClick={() => dispatch({ type: 'closeAll' })}
        >
          {t('workspace.closeAll')}
        </button>
      </span>

      <PoweredBy />
    </div>
  );
}
